import { IHentetKvittering, IKvitteringData, ITilsynstype } from './types'

export const kvitteringActionTypes = {
  SET_CURRENT_KVITTERING_FROM_ID:
    'current-kvittering/SET_CURRENT_KVITTERING_FROM_ID' as const,
  SET_CURRENT_KVITTERING_FROM_ID_FAILED:
    'current-kvittering/SET_CURRENT_KVITTERING_FROM_ID_FAILED' as const,
  SET_CURRENT_KVITTERING: 'current-kvittering/SET_CURRENT_KVITTERING' as const,

  CLEAR_CURRENT_KVITTERING:
    'current-kvittering/CLEAR_CURRENT_KVITTERING' as const,
  CLEAR_ERROR: 'current-kvittering/CLEAR_ERROR' as const,
  FETCH_SAMMENSTILLING: 'kvittering/FETCH_SAMMENSTILLING' as const,
  FETCH_SAMMENSTILLING_SUCCESS:
    'kvittering/FETCH_SAMMENSTILLING_SUCCESS' as const,
  FETCH_SAMMENSTILLING_FAILED:
    'kvittering/FETCH_SAMMENSTILLING_FAILED' as const,
  SET_STATUS: 'current-kvittering/SET_STATUS' as const,
  UPDATE_CURRENT_KVITTERING:
    'current-kvittering/UPDATE_CURRENT_KVITTERING' as const,
  UPDATE_CURRENT_KVITTERING_SUCCESS:
    'current-kvittering/UPDATE_CURRENT_KVITTERING_SUCCESS' as const,
  UPDATE_CURRENT_KVITTERING_FAILED:
    'current-kvittering/UPDATE_CURRENT_KVITTERING_FAILED' as const,
  INITIAL_STATE: 'kvittering/INITIAL_STATE' as const,
  FETCH_KVITTERING_BY_ID: 'kvittering/FETCH_KVITTERING_BY_ID' as const,
  FETCH_KVITTERING_BY_ID_SUCCESS:
    'kvittering/FETCH_KVITTERING_BY_ID_SUCCESS' as const,
  FETCH_KVITTERING_BY_ID_FAILED:
    'kvittering/FETCH_KVITTERING_BY_ID_FAILED' as const,
  FETCH_TILSYNSTYPER: 'kvittering/FETCH_TILSYNSTYPER' as const,
  FETCH_TILSYNSTYPER_SUCCESS: 'kvittering/FETCH_TILSYNSTYPER_SUCCESS' as const,
  FETCH_TILSYNSTYPER_FAILED: 'kvittering/FETCH_TILSYNSTYPER_FAILED' as const,
  FETCH_KVITTERINGER_FRA_KOLLEGA:
    `kvittering/FETCH_KVITTERINGER_FRA_KOLLEGA` as const,
  FETCH_KVITTERINGER_FRA_KOLLEGA_SUCCESS:
    `kvittering/FETCH_KVITTERINGER_FRA_KOLLEGA_SUCCESS` as const,
  FETCH_KVITTERINGER_FRA_KOLLEGA_FAIL:
    `kvittering/FETCH_KVITTERINGER_FRA_KOLLEGA_FAIL` as const,
  INIT: 'kvittering/INIT' as const,
  CLEAN_SYNC_STATE: 'kvittering/CLEAN_SYNC_STATE' as const,
  SET_CURRENT_KVITTERING_ID: 'kvittering/SET_CURRENT_KVITTERING_ID' as const,
  CLEAR_CURRENT_KVITTERING_ID:
    'kvittering/CLEAR_CURRENT_KVITTERING_ID' as const,
}

export const kvitteringActions = {
  initialState: () => ({
    type: kvitteringActionTypes.INITIAL_STATE,
  }),

  fetchKvitteringById: (id: string) => ({
    type: kvitteringActionTypes.FETCH_KVITTERING_BY_ID,
    id,
  }),

  fetchKvitteringByIdSuccess: (payload) => ({
    type: kvitteringActionTypes.FETCH_KVITTERING_BY_ID_SUCCESS,
    payload,
  }),

  fetchKvitteringByIdFailed: (error: string) => ({
    type: kvitteringActionTypes.FETCH_KVITTERING_BY_ID_FAILED,
    error,
  }),

  clearCurrentKvittering: () => ({
    type: kvitteringActionTypes.CLEAR_CURRENT_KVITTERING,
  }),
  setCurrentKvitteringFromId: (
    tilsynskvitteringId: string,
    expand?: string[]
  ) => ({
    type: kvitteringActionTypes.SET_CURRENT_KVITTERING_FROM_ID,
    tilsynskvitteringId,
    expand,
  }),
  setCurrentKvitteringFromIdFailed: (error: string) => ({
    type: kvitteringActionTypes.SET_CURRENT_KVITTERING_FROM_ID_FAILED,
    error,
  }),

  setCurrentKvittering: (kvittering) => ({
    type: kvitteringActionTypes.SET_CURRENT_KVITTERING,
    kvittering,
  }),
  clearError: () => ({
    type: kvitteringActionTypes.CLEAR_ERROR,
  }),

  setStatus: (status) => ({
    type: kvitteringActionTypes.SET_STATUS,
    status,
  }),

  fetchSammenstilling: () => ({
    type: kvitteringActionTypes.FETCH_SAMMENSTILLING,
  }),

  fetchSammenstillingSuccess: (kvittering) => ({
    type: kvitteringActionTypes.FETCH_SAMMENSTILLING_SUCCESS,
    kvittering,
  }),

  fetchSammenstillingFailed: (error) => ({
    type: kvitteringActionTypes.FETCH_SAMMENSTILLING_FAILED,
    error,
  }),

  updateCurrentKvittering: (payload: Partial<IKvitteringData>, delay = 0) => ({
    type: kvitteringActionTypes.UPDATE_CURRENT_KVITTERING,
    payload,
    delay,
  }),

  updateCurrentKvitteringSuccess: () => ({
    type: kvitteringActionTypes.UPDATE_CURRENT_KVITTERING_SUCCESS,
  }),

  updateCurrentKvitteringFailed: (error) => ({
    type: kvitteringActionTypes.UPDATE_CURRENT_KVITTERING_FAILED,
    error,
  }),

  fetchTilsynstyper: () => ({
    type: kvitteringActionTypes.FETCH_TILSYNSTYPER,
  }),

  fetchTilsynstyperSuccess: (tilsynstyper: ITilsynstype[]) => ({
    type: kvitteringActionTypes.FETCH_TILSYNSTYPER_SUCCESS,
    tilsynstyper,
  }),

  fetchTilsynstyperFailed: (error: string) => ({
    type: kvitteringActionTypes.FETCH_TILSYNSTYPER_FAILED,
    error,
  }),
  cleanSyncState: () => ({
    type: kvitteringActionTypes.CLEAN_SYNC_STATE,
  }),
  fetchKvitteringerFraKollega: (userId: string) => ({
    type: kvitteringActionTypes.FETCH_KVITTERINGER_FRA_KOLLEGA,
    userId,
  }),
  fetchKvitteringerFraKollegaSuccess: (kvitteringer: IHentetKvittering[]) => ({
    type: kvitteringActionTypes.FETCH_KVITTERINGER_FRA_KOLLEGA_SUCCESS,
    kvitteringer: kvitteringer,
  }),
  fetchKvitteringerFraKollegaFail: (error: string) => ({
    type: kvitteringActionTypes.FETCH_KVITTERINGER_FRA_KOLLEGA_FAIL,
    error: error,
  }),
  setCurrentKvitteringId: (kvitteringId: string) => ({
    type: kvitteringActionTypes.SET_CURRENT_KVITTERING_ID,
    kvitteringId,
  }),
  clearCurrentKvitteringId: () => ({
    type: kvitteringActionTypes.CLEAR_CURRENT_KVITTERING_ID,
  }),
}
